<template>
  <v-select
    v-model="item"
    :items="items"
    :rules="[rules.required]"
    :loading="isLoading"
    :error-messages="error"
    label="Veículo*"
    item-text="plate"
    return-object
    clearable
    outlined
    dense
    @input="$emit('input', formatItem(item))"    
  />
</template>

<script>
  import vehicleService from '@/services/vehicle.service';

  export default {
    name: 'OrderVehicleSelect',
    props: {
      value: {
        type: Object,
        default: null
      },
    },
    data: () => ({
      isLoading: false,
      error: null,
      items: [],
      item: null,
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },    
    }),
    mounted() {    
      this.listVehicles();
    },
    methods: {
      listVehicles() {
        this.isLoading = true;
        vehicleService.list().subscribe(response => {
          this.items = response;
          this.isLoading = false;
        }, error => {
          this.error = 'Erro ao carregar os veículos';
          this.isLoading = false;
        });
      },
      formatItem(item) {
        if (!item) return null;
        return {
          plate: item.plate,
          transportId: item.company_vehicle_id
        };
      }
    },
  };
</script>